// extracted by mini-css-extract-plugin
export default {"root":"ContestReattempt_root__lcEGR","header":"ContestReattempt_header__ey-1F","body":"ContestReattempt_body__LXs-e","neutralScale7":"ContestReattempt_neutralScale7__yglyj"};